// extracted by mini-css-extract-plugin
export default {"container":"fUyZon5XDlgAtHdL8Oqp","resizing":"Lfgwl6RWGnsFJtoUs9Gy","shadowRow":"n4LfRjgnnfk91zu2M5lb","overflowContent":"ivFfN2UYDnsgg7VWLzVf"};